import React from 'react';
import "./tournament-players-removed-list.scss"
import {useMatch, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
  selectTeamsNotifications,
  clearNotifications,
  selectLoading,
  selectTournamentRemovedPlayers, setCurrentUnassignedPlayer
} from "../../../reducers/teamsSlice";
import {faChevronLeft, faComment, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import {GSActionBar, GSEmptyList, GSItemList, GSSidePanelPage} from "golfstatus_react_components";
import {useNotificationBanner} from "../../../hooks/notificationHooks";
import TournamentPlayersRemovedItem from "./tournament-players-removed-item";
import {getNotificationItemInfo} from "../../../helpers/Converters";
import {addNotification} from "../../../reducers/teamsSlice";
import {selectCurrentTournament} from "../../../reducers/tournamentSlice";

const TournamentPlayersRemovedList = () => {
  //hooks
  const navigate = useNavigate();
  const match = useMatch("/:tournamentID/teams/removed-players");
  const dispatch = useDispatch();

  //selectors
  const currentTournament = useSelector(selectCurrentTournament);
  const removedPlayers = useSelector(selectTournamentRemovedPlayers);
  const notifications = useSelector(selectTeamsNotifications);
  const loading = useSelector(selectLoading);

  //custom hooks

  //effects

  //context

  //component functionality
  const getMessage = (player) => {
    return {
      header: getNotificationItemInfo(
        player.signupMessage,
        faComment,
        player.contactName
      ),
      state: "grey",
      bannerActions: [
        {
          actionIcon: faTimesCircle,
          actionClick: () => {
            dispatch(clearNotifications());
          },
        },
      ],
    };
  };

  const showMessage = (player) => {
    dispatch(addNotification(getMessage(player)));
  };

  const leftNavigation = () => {
    timeoutAction();
    navigate(-1);
  };

  const isSidePanelOpen = () => {
    return match?.params?.["*"] !== "";
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Removed Players`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getPlayerGroupList = (item) => {
    return <TournamentPlayersRemovedItem {...item} isHandicapScoring={currentTournament?.handicapScoring} messageClicked={showMessage} />;
  };

  const getEmptyListMessage = () => {
    return (
      <GSEmptyList
        title="Removed Players"
        detail="No players have been removed."
      />
    );
  };

  const itemSelected = (item) => {
    if (isSidePanelOpen()) {
      dispatch(setCurrentUnassignedPlayer(item));
      navigate(`/${match?.params?.tournamentID}/teams/unassigned-players/${item.id}/edit`);
    }
  };

  const getContent = () => {
    return (
      <>
        <GSActionBar
          type="form-header"
          header={`Removed Players (${removedPlayers ? removedPlayers.length : 0})`}
        ></GSActionBar>
        <gs-form>
          <GSItemList
            type="vertical selectable"
            items={removedPlayers}
            listItem={(item) => getPlayerGroupList(item)}
            emptyMessage={getEmptyListMessage()}
            itemSelected={itemSelected}
          ></GSItemList>
        </gs-form>
      </>
    );
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-players-removed-list>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        loading={loading.length !== 0}
      ></GSSidePanelPage>
    </tournament-players-removed-list>
  );
};

export default TournamentPlayersRemovedList;
